<template>
    <div class="box">
        <div class="content">
            <p>
                <el-input v-model="username" placeholder="请输入手机号"></el-input>
            </p>
            <p>
                <el-input v-model="password" placeholder="请输入密码" show-password></el-input>
            </p>
            <p>
                <el-button type="primary" @click="sing_in(1)">注册</el-button>
            </p>
            <p>
                <el-button type="success" @click="sing_in(0)">返回登录</el-button>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            username: "",
            password: "",
        };
    },
    methods: {
        sing_in(i) {
            if (i == 1) {
                if (this.username == "" || this.password == "") {
                    this.$message.error("手机号或密码不能为空！"); return;
                }
                let formData = {
                    username: this.username,
                    password: this.password
                }
                this.$message.success("用户注册成功，请点击登录进行登录！");
                window.sessionStorage.setItem('user', JSON.stringify(formData));
                this.$router.replace('/login');
            } else {
                this.$router.replace('/login');
            }

        },
    },
};
</script>

<style lang="less" scoped>
.box {
    width: 100vw;
    height: 100vh;
    background-image: linear-gradient(to right, #f78da7, #f5f78d);

    overflow: hidden;
}

.content {
    width: 500px;
    height: 300px;
    box-sizing: border-box;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.7);
    margin: calc(50vh - 150px) auto;
    padding: 20px;
}

.el-button {
    width: 100%;
}
</style>
